import { render, staticRenderFns } from "./DonutChart62.vue?vue&type=template&id=56ab1b52&scoped=true"
import script from "./DonutChart62.vue?vue&type=script&lang=js"
export * from "./DonutChart62.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ab1b52",
  null
  
)

export default component.exports